window.i18n = {
    "messages": {
        "typical_food": "Typical food",
        "dishes_not_miss": "Dishes you can't miss",
        "country_typical_food": "Typical food of",
        "read_more": "Read more details",
        "read_less": "Read fewer details",
        "see_other_destinations": "See other destinations in",
        "hotels": "Hotels",
        "break_weekend": "Weekend break",
        "destination_title": "Take advantage of any occasion to travel",
        "escape_two_weeks": "Escape in two weeks",
        "plan_vacation": "Plan your vacation",
        "enjoy_weather": "Enjoy the weather",
        "tips_weather": "Tips to enjoy the weather",
        "weather_at": "The weather in",
        "prepare_luggage": "Prepare your luggage for",
        "what_expect_weather": "What to expect from the weather in",
        "current_conditions": "Current conditions",
        "code_weather": "°C",
        "min": "min",
        "max": "max",
        "full_forecast": "Full forecast",
        "see_more": "See more",
        "see_less": "See less",
        "know_destinations": "Discover destinations and travel options in",
        "points_pricetravel": "{0} <br/> Sales Points",
        "select_atention": "Sales points",
        "home": "Home",
        "points_pricetravel_desc": "Personalized advice for everything you need for your trip.",
        "help_you_organize": "We help you organize your trip",
        "search_pdv": "Search your sales point",
        "state": "State",
        "all": "All",
        "custom_guide": "Personalized advice",
        "custom_guide_desc": "We ensure to provide you with the best options for every detail of your trip.",
        "easy_access_schedule": "Easy access and extended hours",
        "easy_access_schedule_desc": "We are located in shopping centers and open 7 days a week.",
        "pay_easy": "Pay easily and safely",
        "pay_easy_desc": "We offer various payment methods and a layaway system.",
        "know_paymethods": "Learn about payment methods",
        "back_to_list": "Back to the list",
        "open": "Open",
        "schedule": "Schedule",
        "address": "Address",
        "references": "References",
        "select_option": "Choose a state",
        "phone": "Phone",
        "call": "Call",
        "closed": "Closed",
        "path": "/points-of-sale/",
        "wa_contact": "Contact",
        /**Checkout */
        "secure_your_reservation": "Secure your reservation!",
        "secure_your_reservation2": "Secure your reservation",
        "add_your_info_text": "Enter your information to <strong>ensure the rate and availability</strong> of your trip",
        "secure_your_reservationRAPD": "Book now and pay later!",
        "secure_your_reservationRAPDDetail": "Travel with all benefits: <b>complete the form</b>, secure your place and pay later",
        "this_is_last_step": "!<strong>This is the last step,</strong> just click and save your spot!",
        "hurry_up": "Hurry up!",
        "rate_can_change": "Rate and availability can change in a very short time",
        "enter_your_data": "Traveler Information",
        "method_of_payment": "Payment Information",
        "confirmation": "Confirmation",
        "first_name": "First Name",
        "last_name": "Last name",
        "email": "Email ",
        "here_we_send_itinerary": "We'll send your travel itinerary here",
        "confirm_email": "Confirm email",
        "phone": "Phone number",
        "continue": "Continue booking ",
        "i_have_read": "By clicking 'Continue' you are accepting our",
        "privacy_terms_and_reservation_police": "reservation policies and the privacy policy",
        "type_your_first_name": "Type your first name",
        "type_your_last_name": "Type your last name",
        "type_your_email": "Type your email",
        "type_your_email_again": "Confirm your email",
        "summary_reservation": "Booking details",
        "checkin": "Check in",
        "checkout": "Check out",
        "lodging_days": "night(s) for accommodation",
        "taxes_and_fees": "Taxes",
        "taxes": "taxes",
        "of_taxes": "of taxes",
        "total": "Total",
        "stay_of": "Stay of",
        "nights": "nights",
        "night": "night",
        "per": "per",
        "off": "off discount",
        "room": "room",
        "rooms": "rooms",
        "rooms-title": "Rooms",
        "no-need-pay-today": "Payment is not required today! ",
        "pay-accommodation": "Pay at the property.",
        "all-inclusive": "All Inclusive",
        "guests": "Guests",
        "messagge-fee": "Rates quoted {0} are informative and based on  current exchange rates. You will pay ",
        "messagge-fee-2": "at the property.",
        "messagge-fee-3": "in USD",
        "to": "hasta",
        "price": "Price",
        "pay-accommodation-title": "Pay at accommodation",
        "resort-fee": "Resort fee",
        "months_without_interest": "meses sin intereses",
        "the_best_price": "The best price, guaranteed",
        "the_best_price_description": "If you find a better price on another website for the same stay, we will match it.",
        "more_information": "More information",
        "purchases_safe": "Your purchases at {0} are safe.",
        "for": "For",
        "adults": "adult(s)",
        "children": "child(ren)",
        "and": "and",
        "you_may": "You can",
        "cancel_free": "cancel for free",
        "reservation_until": "this reservation until",
        "reservation_until_h_c": "Until",
        "reservation_until_room": "until",
        "wa_contact": "Contact us",
        "free_cancellation": "FREE cancellation",
        "free_cancellation_room": "FREE cancellation",
        "checkout_title": "Checkout",
        "dates_server_cancellation": "The dates and times correspond to the Mexico City time zone.",
        "description_cancellation_free": "FREE cancellation until 23:59 hrs on",
        "description_cancellation_free_to": " from 00:00 hrs on",
        "description_cancellation_penalty": "your reservation will have a penalty.",
        "close": "Close",
        "cancellation_policy": "Cancellation policies",
        "success_voucher": "Great, get ready to travel!",
        "processing_booking": "We are processing your reservation",
        "reservacion_id": "Booking locator:",
        "we_send_email": "We’ve sent the reservation details to your <span class=\"font-weight-bold text-success \"> {0} </span> sure you receive our messages",
        "description_voucher": "You make sure you receive our messages",
        "description_voucher_detail": "If you don’t see our email within a few minutes, please check your spam or junk folder. <br> If you find it there, mark it as a safe sender to ensure you receive all future communications from {0} without any issues",
        "go_home": "Back to home",
        "thankyou_page": "Confirmation",
        "error_title": "An error has occurred",
        "error_description": "Our apologies. We were unable to obtain the requested information.",
        "error_list_one": "The servers delete the search information after some time of inactivity. This protects your privacy and helps the site work better.",
        "error_list_two_bold": "Link from bookmarks",
        "error_list_two": "The pages that you add to your browser's bookmarks are built with information that is based on your previous selections (such as rates for a specific date). These pages cannot be used to obtain updated information.",
        "RATE_NOT_FOUND": "An error has occurred with the current quote, please call <a href='tel:18554378999'>+1 855 4378 999</a> for follow-up",
        "ROOM_NOT_FOUND": "An error has occurred with the current quote, please call <a href='tel:18554378999'>+1 855 4378 999</a> for follow-up",
        "HOTEL_NOT_FOUND": "Hotel not found",
        "VOUCHER_NOT_FOUND": "Voucher not found",
        "ERROR_DEFAULT": "An error has occurred",
        "rapd_title_summary": "Book now and pay later",
        "total_reservation": "Total",
        "total_booknow": "Pay now",
        "date_limit_booknow": "Pay before",
        "midday": "noon",
        "tax_include": "Includes taxes",
        "tax_no_include": "Taxes no include",
        "bags": "Your reservation is ready!",
        "reservation_number": "Your locator number is",
        "email_reservation_voucher": "We send you a confirmation email to",
        "email_reservation_voucher_description": "the confirmation of your reservation with a locator number, which will help you make your payments.",
        "download_itinerary": "Download Itinerary",
        "date_checkin_checkout": "Arrival and departure date",
        "paxes": "Guests",
        "room_type": "Room type",
        "mealplan": "Meal plan",
        "payment_method": "Payment method",
        "payment_plan": "Payment plan",
        "payment_total": "Total to Pay",
        "payment_pending": "Total to pay",
        "get_invoice": "Obtener factura",
        "cancellation_polcy": "Cancellation policy",
        "cancellation_polcy_legal": "Your reservation has a period in which no penalties apply if you cancel your reservation. Note that this period has a fixed duration. Check details and penalties in your itinerary.",
        "reservation_holder": "Reservation holder",
        "reservation_holder_booking": "Person who will check-in and check-out at the hotel",
        "reservation_card": "Reserve without credit card",
        "price_and_availible": "Guaranteed price and availability",
        "payment_later_interes": "Pay later in installments",
       "residents_colo": "Colombian Residents",
       "residents_peru": "Residents of Peru",
        "detail_residents_colo": "For reservations and stays until December 31, 2022, according to Law 2068 of 2020, a 0% accommodation VAT applies. For stays starting January 1, 2023, Colombians must pay VAT (nineteen percent) directly at the hotel.",
        "detail_residents_peru": "*** Peruvian residents may be required to pay the national VAT (value-added tax) (18%) at the property. Foreign tourists presenting a valid tourist visa or Andean Migration Card along with a valid passport may be exempt from this tax.",
        "residents_extran_detail_info": "The VAT tax also applies to foreigners who stay in the country for at least 60 consecutive days. The tax may apply to the entire room if shared with someone subject to paying the tax.",
        "residents_extran": "Foreigners",
        "residents_extran_detail_info_2": "According to Decree 2646 of the Ministry of Finance and Public Credit of Colombia, individuals residing abroad who purchase a tourist plan or package (lodging + any meals or transportation) are exempt from paying the tax, provided they present their passport with the corresponding Colombian customs immigration stamps at the hotel. This process will be valid as long as hotel check-in occurs within 30 days of entering the country.",
        "please_wait_voucher": "We are processing your reservation, please wait a moment.",
        "resort_feeTitle": "Resort Fee *",
        "resort_fee": "* Resort Fee to pay at the property:",
        "resort_fee_pt1": "You will be asked to pay Resort fee of",
        "resort_fee_pt2": "per room, per night) at the property.Payment will be made in property's local currency.",
        "resort_pay_now": "Pay now",
        "resort_at_property": "Pay at property",
        "colombians_vat_messages": " *For stays from January 1, 2023, Colombians must pay 19% VAT directly at the hotel.",
        "how_make_payment": "How to make your payment",
        "rapd_instruction1": "Make your payment before the date limit",
        "rapd_instruction2": "Pay monthly without interest with participating cards",
        "rapd_instruction3": "Choose the option that suits you best",
        "pay_online": "Pay online",
        "with_credit_or_debit": "We will send you a link so you can make your secure payment online.",
        "see_details_in_email": "",
        "pay_by_phone": "Pay by phone",
        "pay_bank_transfer": "Call us to pay your reservation.",
        "pay_on_pdvs": "Pay at {0} Points of Sale",
        "go_to_our_pdvs": "Visit any of our points of sale and pay with a credit card, debit card, or cash",
        "consult_the_list_pdvs": "Check the list of {0} Points of Sale",
        "booked_with_rapd_benefit": 'You booked with the benefit <strong class="promo-text">book now and pay later</strong>',
        "phone_number_pay": "+1 855 437 8999",
        "phone_number_pay_href": "18554378999",
        "your_reservation_is_confirmed": "Your reservation has been confirmed.",
        "source_triv_gool": "Final cost of your reservation:",
        "special_requests": "Special requests (optional)",
        "we_send_your_requests": "We will send your requests to the hotel, however they are subject to availability and possible additional charges.",
        "special_request_placeh": "Write if you need anything special for your stay (e.g. cots, extra beds, etc.)",
        "with_credit_card": "interest-free months",
        "reservation_message": "Use this number to track your reservation with",
        "site_name": "{0}",
        "review_itinerary": "Review itinerary",
        "pay_aloj": "You will pay at the accommodation",
        "pay_hotel_collect": "You will pay at the accommodation",
        "pay_hotel_collect_1": "Rates quoted in mexican pesos are informative and based on current exchange rates. You will pay",
        "pay_hotel_collect_2": "at the property + additional charges",
        "error_reserv": "Sorry. The selected option is no longer available.",
        "discount_title": "We found a better price!",
        "discount_title_2": "You already have the best price available",
        "discount_subtitle": "Apply a discount of",
        "discount_subtitle_2": "on your reservation",
        "discount_applicable": "A discount of has been applied",
        "birthday": "Date of birth",
        "nationality": "Nationality",
        "genre": "Gender",
        "no_refundable":"Not refundable",
    },
    "url": {
        "url_terms": "/info/terms-and-conditions",
        "url_best_price": "/help_us/price_garantee",
        "url_go_home": "/",
        "url_go_itinerary_pricetravel": "/ayuda/reservacion",
        "url_go_itinerary_tiquetesbaratos": "/ayuda/tiquetes-baratos/reservacion",
        "url_detail": "hotel/",
        "url_list": "hotels/",
        "url_destination": "destination"
    },
    "breakdown": {
        "TaxExcluded": "Taxes not included",
        "TaxExcluded_CO": "For local residents only",
        "TaxIncluded": "Taxes included",
        "HotelFees": "Hotel fees",
        "ResortFees": "Resort fee",
        "ResortFee": "Resort fee",
        "ResortFees_sub": "to be paid at the accommodation",
        "ResortFee_sub": "to be paid at the accommodation",
        "HotelMandatoryTax_sub": "to be paid at the accommodation",
        "HotelMandatoryFee_sub": "to be paid at the accommodation",
        "HotelMandatoryTax": "Local residents only",
        "HotelMandatoryFee": "Mandatory hotel fees",
        "HospitalityTax": "Hospitality insurance",
        "HospitalityTax_sub": "Per person for the entire stay",
        "charges_not_included": "Additional charges",
              "HotelMandatoryService": "Accommodation service charge",
                      "HotelMandatoryService_sub": "to be paid at the accommodation"


    },
    "mealplans": {
        "A": "American breakfast",
        "AA": "Imperial Christmas and New Years Eve",
        "AB": "Romantic Getaway",
        "AC": "Romantic Getaway and Spa",
        "AD": "Lunch and dinner with drinks",
        "AE": "Breakfast (adults only)",
        "AF": "Gourmet American Breakfast",
        "AG": "Breakfast for 2",
        "AH": "Continental Breakfast for 2",
        "AI": "Breakfast & lunch",
        "AJ": "Breakfast, lunch, dinner with liquids",
        "AK": "Semi All Inclusive",
        "AL": "3 meals + 2 snacks",
        "AM": "Dining Plan",
        "AN": "Quick Service",
        "AO": "Breakfast, lunch or dinner included, beverages not included",
        "AP": "Breakfast, snack & dinner included",
        "AQ": "Breakfast, lunch or dinner included",
        "AR": "Non Refundable",
        "AS": "Drinks Included",
        "AT": "Breakfast, lunch, and dinner available only for adults",
        "AU": "Continental breakfast adults only",
        "AV": "Breakfast – nonrefundable",
        "AW": "Food, Beverages and Tours included",
        "AX": "Breakfas for 1 adult",
        "AY": "Dinner",
        "AZ": "All Inclusive",
        "B": "Buffet breakfast",
        "BA": "Premium",
        "C": "Lunch",
        "E": "Room Only",
        "F": "Breakfast & dinner included",
        "G": "Breakfast, lunch & dinner included",
        "H": "Breakfast, lunch or dinner included",
        "I": "All Inclusive",
        "J": "Continental breakfast buffet",
        "K": "All Inclusive",
        "L": "Breakfast",
        "M": "Breakfast & dinner with beberages",
        "N": "Breakfast without beverages",
        "O": "Open Bar",
        "P": "Breakfast & dinner, no drinks",
        "Q": "Breakfast, lunch & dinner, no drinks",
        "R": "Buffet breakfast, no beverages",
        "S": "Breakfast and lunch or dinner, beverages not included",
        "T": "Lunch without beverages",
        "U": "2 quick service meals + 1 snack",
        "V": "2 meals + 1 snack",
        "W": "3 meals, no beverages",
        "X": "Dinner without beverages",
        "Y": "Continental breakfast without beverages",
        "Z": "Continental breakfast",
        "AR": "Room Only",
        "BA": "All Inclusive Premium",
        "BB": "Resort credit included",
        "BZ": "Buffet breakfast",
        "EL": "Room Only with promo",
        "GR": "Breakfast, lunch & dinner included",
        "HR": "Breakfast, lunch or dinner included",
        "KR": "Food and drinks included",
        "MR": "Breakfast & dinner with beberages",
        "PR": "Breakfast and Dinner",
        "XB": "Golf AM - Buffet breakfast",
        "XE": "Golf AM - Room Only",
        "ZA": "American breakfast",
        "ZR": "Continental breakfast"
    },
    "errors": {
        "_default": "The field is not valid",
        "alpha": "The field can only contain letters",
        "alpha_spaces": "The field can only contain letters",
        "confirmed": "Field does not match",
        "email": "Must be an email field",
        "required": "The field is required",
        "integer": "The field can only be digits",
    },
    "formaters": {
        "cancellation": "LLLL",
        "rapd": "MMM, D, YYYY"
    },
    "checkout": {
        "note_charge": "The fees displayed in {1} are for informational purposes and are based on the current exchange rate from {1} to {0}.",
        "pay_will_be": "Your payment will be for ",
           "pay_will_be_meta": "Your payment will be in"
    },
    "breadcrumbs": {
        "home": "Home",
        "info": "Site Information",
        "about-us": "About us",
        "legal": "Legal",
        "terms-and-conditions": "Terms and Conditions",
        "privacy-policy": "Privacy Policy",
        "profeco-contract": "Profeco Adhesion Contract",
        "mx": "Mexico",
        "global": "USA & Rest of the World",
        "user": "User",
        "profile": "Profile",
        "companions": "Additional persons",
        "security": "Your Account Security",
        "reservations": "Reservations and trips",
        "usuario": "User",
        "perfil": "Profile",
        "acompañantes": "Additional persons",
        "seguridad": "Your Account Security",
        "reservaciones": "Reservations and trips",
    },
    "information": {
        "lang_es": "Spanish",
        "lang_us": "English",
        "mx": "Mexico",
        "us": "United States",
        "faq": "Frequently Questions",
        "about_us_title": "We welcome you to {0}.com",
        "no_results": "No results",
        "select_location": "Select your location",
        "site_information": "Site Information",
        "payment_methods": "Payment Methods",
        "payment_methods_description": "Learn about available payment methods",
        "billing": "Billing",
        "billing_description": "Learn how to easily get your reservation invoice",
        "about_site": "About",
        "about_site_description": "Discover more about our company, mission and values"
    },
    "security": {
        "email_subtitle": "This is the email you use to log in and where you receive confirmation of your reservations",
        "verified": "Verified",
        "password": "Password",
        "change": "Change",
        "modify_password": "Modify password",
        "check_inbox": "Check your inbox",
        "password_instructions": "We'll send an email with password reset instructions to:",
        "password_instructions_sent": "We've sent an email with password reset instructions to:",
        "email_valid_time": "Once it arrives, it will be valid for 60 minutes.",
        "send": "Send",
        "resend": "Resend",
    },
    "profile": {
        "profile": "Profile",
        "session_name": "Name",
        "pending": "Pending",
        "edit": "Edit",
        "first_name": "First Name(s)",
        "last_name": "Last Name(s)",
        "cancel": "Cancel",
        "update_perfil": "Update Profile",
        "phone_login": "Phone",
        "birthdate": "Date of Birth",
        "nationality": "Nationality",
        "genre": "Gender",
        "account_security": "Your Account Security",
        "account_email_message": "Email",
        "header_redirect": "Back",
        "email": "Email",
        "passport": "Passport",
        "previus": "Previous",
        "next": "Next",
        "day": "Day",
        "month": "Month",
        "year": "Year",
        "man": "Man",
        "fem": "Woman",
        "na": "Prefer not to say",
        "optional": "Optional",
        "paxes_subtitle": "Add information about the people who accompany you on your trips.",
        "add_paxes": "Add additional person",
        "new_companion": "New companion",
        "save": "Save",
        "delete_paxe": "Delete companion",
        "terms": "By selecting 'Save', you agree that PriceTravel.com retains the data entered.",
        "message_important": "Enter your companion's information exactly as it appears on their official ID.",
        "account": "Account",
        "reservations": "Reservations",
        "warningDelete": "Are you sure you want to remove this companion?",
        "accept": "Accept",
        
    },
    "account": {
        "reservations_title": "Bookings and Trips",
        "profile_title": "Profile",
        "paxes_title": "Additional Guests",
        "favorites_title": "Favorites",
        "security_title": "Account Security",
        "service_title": "Customer Service",

        "reservations_description": "Review your upcoming bookings, travel history, and trip details",
        "profile_description": "View and update your personal information",
        "paxes_description": "Add or edit details of those traveling with you",
        "favorites_description": "Save your favorite hotels",
        "security_description": "Change your password",
        "service_description": "Contact us or request personalized assistance"
    },
    "reservations": {
        "reservation_trips": "Reservations and trips",
        "cant_find_reservation": "Can't find a reservation?",
        "ok": "Complete",
        "progress": "Pending payment",
        "past": "Past",
        "cancelled": "Cancelled",
        "quote": "Quotes",
        "completed": "Complete",
        "locator": "Locator",
        "where_to_go": "Where would you like to go?",
        "no_upcoming_trips": "You don't have any upcoming trips yet",
        "search_trip_options": "Search for trip options",
        "cant_find_reservation": "Can't find a reservation?",
        "Cancel": "Cancel",
        "see_itinerary": "View Travel Itinerary",
        "pay_reservation": "Pay reservation",
        "total": "Total to pay",
        "upcoming": "Upcomings",
        "progressTitle": "Payment pending",
        "new_reservation": "Find your booking",
        "instructions": "To manage your reservation, enter the confirmation code and email address.",
        "not_found": "Sorry, we couldn't find a reservation matching that localizator or email. Please check your information and try again.",
        "localizator": "Locator number",
        "email": "Email Address",
        "search": "Search",
        "cancel": "Cancel",
        "trash": "Cancel",
        "cant_find_url_payment": "There was a problem trying to pay for the reservation. It may be canceled or no longer available."
    },
    "legal": {
        "legal_info": "Legal information",
        "mx": "Mexico",
        "global": "USA & Rest of the World",
        "on_this_page_mx": "En esta página",
        "on_this_page_global": "On this page",
        "terms_and_conditions": "Terms and Conditions",
        "terms_and_conditions_mx": "Términos y condiciones",
        "terms_and_conditions_global": "Terms and Conditions",
        "terms_conditions_description": "Review the terms and conditions applicable to {0}.",
        "terms_conditions_notification_mx": "If your country of residence is other than Mexico or you made a reservation on the site outside of Mexico, the <a href='{0}'>USA and Rest of the World Terms</a> and Conditions apply to you.",
        "terms_conditions_notification_global": "If your country of residence is Mexico or you made a reservation on the site from Mexico, the <a href='{0}'>Mexico Terms and Conditions</a> apply to you.",
        "privacy_policy": "Privacy Policy",
        "privacy_policy_mx": "Política de privacidad",
        "privacy_policy_global": "Privacy Policy",
        "privacy_policy_description": "Learn how we protect the data you provide us through our channels.",
        "profeco_contract_mx": "Profeco Adhesion Contract",
        "profeco_contract_description": "Information for buyers in Mexico.",
    },
    "months": {
        "01": "January",
        "02": "February",
        "03": "March",
        "04": "April",
        "05": "May",
        "06": "June",
        "07": "July",
        "08": "August",
        "09": "September",
        "10": "October",
        "11": "November",
        "12": "December",
    },
    "payment": {
        "payOnline-title": "Online payment",
        "payOnline-subtitle": "Enter your reservation code and pay online. (We accept all debit and credit cards).",
        "payOnline-code": "Locator",
        "payOnline-email": "Email (the one you used to book)",
        "payOnline-consult": "Consult",
        "secure-payments": "Convenient and secure payments",
        "check-methods-pay": "Check our payment methods",
        "payment-option-depend": "*Installment payment options depend on the selected service and the purchase amount",
        "payOnline-codePlaceHolder": "Ej. 129668555",
        "payOnline-emailPlaceholder": "Ej. ejemplo@correo.com",
        "method_payments": "Payment methods",
        "tc_td": "We accept all credit and debit cards",
        "until": "Until",
        "quotas": "quotas",
        "payments_options": "Installment payment options depend on the service selected and the value of the purchase",
        "have_credit_card": "Don't you have a credit card?",
        "more_payments_methods": "We have more payment methods:",
        "bancolombia_btn": "Bancolombia Button",
        "bancolombia_pay_online": "Pay online with your Bancolombia savings or current account",
        "PSE_payment": "Online payment with PSE",
        "PSE_pay_online": "Pay online with your checking or savings account",
        "cash": "Cash",
        "pay_cash": "Pay in cash at your nearest location:",
        "effecty_pay": "Pay in cash with the collection code 112232 and the payment reference at any effective point nationwide",
        "bank_deposit": "Bank Deposit",
        "deposit_pay": "Pay online with your checking or savings account",
        "consult": "Consult",
        "title_token": "Your reservation details are as follows",
        "description": "Mr/Mrs {0}, in case of doubts, you can contact us at our helpline:",
        "tel_tiquetesbaratos": "<a href='tel:6017436620'>601 743 6620 </a>",
        "tel_pricetravel": "<a href='tel:8552468484'>(855) 246 8484 </a>",
        "owner_name": "In the name of",
        "owner_email": "Email",
        "total_amount": "For a total of",
        "go_back": "Go back to the beginning",
        "create_link": "Proceed to pay",
        "error": "An error occurred while checking the reservation data",
        "cancelled": "The reservation has been canceled",
        "not_found": "We could not find your reservation",
        "success": "Your reservation details",
        "description_cancelled": "You can try creating a new reservation on our portal, for any doubts, you can contact us at our helpline",
        "description_not_found": "Check if you entered the correct details, for any doubts, you can contact us at our helpline",
        "paid_amount": "Amount paid",
        "balance_amount": "Pending amount",
        "recaptcha_error": "Please verify the recaptcha",
        "try_again": "Try again",
        "without_results": "No results",
    },
};
